<template>
    <b-modal size="lg" id="usersModal" hide-footer no-close-on-backdrop hide-header-close centered>
        <CreateUser v-if="action.action === 'createUser'" :action="action"> </CreateUser>

        <DeleteBrand v-if="action.action === 'deleteBrand'" :action="action"> </DeleteBrand>

        <ChangeAccess v-if="action.action === 'changeAccess'" :action="action"> </ChangeAccess>
    </b-modal>
</template>

<script>
import CreateUser from "../actions/CreateUser";
import DeleteBrand from "../actions/DeleteBrand";
import ChangeAccess from "../actions/ChangeAccess";

export default {
    props: ["action"],
    data() {
        return {};
    },
    components: {
        CreateUser,
        DeleteBrand,
        ChangeAccess
    },
    watch: {},
    mounted() {},
    methods: {},
    computed: {},
    created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Modal.vue?25bae1be